
import Vue from "vue";
import VueRouter from "vue-router";
import { casLogin, getUserInfo, currentUseMake } from '@/api/index'
import { MessageBox, Message } from "element-ui";

// 获取路径?后面的参数
export const queryStringFn = (str) => {
    let params = str.split("?")[1];
    let param = params ? params.split("&") : [];
    let obj = {};
    for (let i = 0; i < param.length; i++) {
        let paramsA = param[i].split("=");
        let key = paramsA[0];
        let value = paramsA[1];
        obj[key] = value;
    }
    return obj;
}

export const LoginFn = (to, next) => {
    let vueConfig = JSON.parse(sessionStorageProxy.getItem('vueConfig'))
    let CASLOGIN = Number(vueConfig && vueConfig.CASLOGIN || 0)

    let urlData = queryStringFn(window.location.href);
    if (urlData && urlData.token && urlData.token != '') { //判断参数是否存在
        casLogin({ token: urlData.token }).then(res => {
            if (res.data.status) {
                sessionStorageProxy.setItem("loginType", CASLOGIN > 0 ? "cas" : "remLogin")
                sessionStorageProxy.setItem("token", res.data.data.token);
                getUserInfoFn(next);
            } else {
                if ( CASLOGIN > 0) {
                  loginFailConfirm()
                } else {
                  MessageBox.confirm('登录失败！即将跳转登录页！', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    showClose: false,
                    showCancelButton: false,
                    closeOnClickModal: false,
                    type: 'warning'
                }).then(() => {
                  window.location.href = window.location.href.split('?')[0]
                })
              }
            }
        }).catch(err => {
            sessionStorageProxy.removeItem("token");
            if ( CASLOGIN > 0) {
              loginFailConfirm()
            } else {
              MessageBox.confirm('登录失败！即将跳转登录页！', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                showClose: false,
                showCancelButton: false,
                closeOnClickModal: false,
                type: 'warning'
            }).then(() => {
              window.location.href = window.location.href.split('?')[0]
            })
          }
        });
    } else {
        if (CASLOGIN == 1) {
            window.location.href = `${vueConfig.CASSSERVICE}/static/sso/login?redirectUrl=${(vueConfig.VUESERVICE)}`;
        } else {
            to.name !== 'login' ? next({ path: '/login' }) : next();
        }
    }

}

//获取用户信息
export const getUserInfoFn = (next) => {
    getUserInfo({ token: sessionStorageProxy.getItem("token") }).then((res) => {
        console.log(res)
        if (res.data.status) {
            console.log('进入了，开始查询缓存')
            sessionStorageProxy.setItem("userInfo", JSON.stringify(res.data.data));
            let firstLogin = localStorageProxy.getItem("firstLogin") //首次登录系统
            if (firstLogin == undefined) {
                localStorageProxy.setItem("firstLogin", true) //第一次登录系统
            }
            console.log('开始进入首页')
            next({ path: "/main/home" });
        } else {
            loginFailConfirm()
        }
    }).catch((err) => {
        console.log(`获取用户信息Error:${err}`);
        loginFailConfirm()
    });
}

//获取当前预约
export const getCurrentBookFun = (callback) => {
    currentUseMake().then(res => {
        if (res.data.status) {
            callback(res.data.data)
        } else {
            this.$error(res.data.message)
        }
    }).catch(err => {
        console.error(`获取当前有效预约Error:${err}`);
        this.$error("服务异常，请联系管理员")
    })
}


const loginFailConfirm = () => {
    let vueConfig = JSON.parse(sessionStorageProxy.getItem('vueConfig'))
    //询问用户是否重新登录
    MessageBox.confirm('登录失败，是否重新触发统一认证？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(() => {
        window.location.href = `${vueConfig.CASSSERVICE}/static/sso/login?redirectUrl=${(vueConfig.VUESERVICE)}`;
    }).catch(() => {
        Message({
            message: '当前登录已取消！',
            type: 'warning'
        });
    });
}


// WEBPACK FOOTER //
// ./src/lib/login.js